import type { HermesGuardFn } from '@/router/guards/types'
import { useFeatureFlags } from '@/utils/useFeatureFlags'

const PHONE_ORDERING_ROUTES = new Set([
  'brand.tools.phone-ordering',
  'brand.tools.phone-ordering.calls',
  'brand.tools.phone-ordering.overview',
])

export const PHONE_ORDERING_FEATURE_FLAG = 'hermes.phoneOrdering'

export const checkPhoneOrderingFeatureFlag: HermesGuardFn = async (to) => {
  if (typeof to.name !== 'string' || !PHONE_ORDERING_ROUTES.has(to.name)) {
    return undefined
  }

  const featureFlags = useFeatureFlags()

  if (!featureFlags.isEnabled(PHONE_ORDERING_FEATURE_FLAG)) {
    return {
      name: 'brand.tools.phone-tree',
      params: { brandId: to.params.brandId },
    }
  }

  return undefined
}
